import { createApp } from 'vue';
import ConfirmDialog from '@/components/utils/ConfirmDialog.vue';

export function useConfirm() {
  const confirm = (options = {}) => {
    const {
      title = 'Confirmação',
      message = 'Tem certeza?',
      confirmText = 'Sim',
      cancelText = 'Não',
      ...props
    } = options;

    return new Promise((resolve, reject) => {
      // Criar um container temporário
      const container = document.createElement('div');
      document.body.appendChild(container);

      // Criar a instância do componente
      const app = createApp(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText,
        ...props
      });

      const instance = app.mount(container);

      // Mostrar o diálogo e aguardar resposta
      instance.show()
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        })
        .finally(() => {
          // Limpar após uso
          setTimeout(() => {
            app.unmount();
            if (container.parentNode) {
              container.parentNode.removeChild(container);
            }
          }, 300);
        });
    });
  };

  return {
    confirm
  };
}

// Função global para compatibilidade com o código existente
export function installConfirm(app) {
  app.config.globalProperties.$confirm = (options) => {
    const { confirm } = useConfirm();
    
    if (typeof options === 'object' && options.callback) {
      // Formato antigo com callback
      const { callback, button = {}, ...otherOptions } = options;
      
      confirm({
        confirmText: button.yes || 'Sim',
        cancelText: button.no || 'Não',
        ...otherOptions
      })
        .then(() => callback(true))
        .catch(() => callback(false));
    } else {
      // Formato novo com Promise
      return confirm(options);
    }
  };
} 